const SESSION_STORAGE_KEYS: string[] = [];

// @ts-ignore
const innerStorage: any = {
    data: {},
    getItem: (key: string) => innerStorage.data[key],
    // @ts-ignore
    setItem: (key: string, value: any) => (innerStorage.data[key] = value),
    removeItem: (key: string) => {
        delete innerStorage.data[key];
    },
    clear: () => {
        innerStorage.data = {};
    },
};

const checkIfStorageExist = () => window && sessionStorage && localStorage;

const BrowserStorage = {
    // @ts-ignore
    setItem: (key: string, value: any) => BrowserStorage.getStorage(key).setItem(key, value),
    getItem: (key: string) => {
        const value = BrowserStorage.getStorage(key).getItem(key);

        try {
            if (value) {
                return JSON.parse(value);
            }
        } catch (err) {
            return value;
        }
    },
    removeItem: (key: string) => BrowserStorage.getStorage(key).removeItem(key),
    getStorage: (key: string) => {
        if (!checkIfStorageExist()) return innerStorage;

        if (SESSION_STORAGE_KEYS.includes(key)) return sessionStorage;

        return localStorage;
    },
    clear: () => {
        if (!checkIfStorageExist()) {
            innerStorage.clear();

            return;
        }

        localStorage.clear();
    },

    clearExcept: (ignoredKeys: string[] = []) => {
        const storages = checkIfStorageExist() ? [localStorage, sessionStorage] : [innerStorage];

        storages.forEach((storage) => {
            Object.keys(storage).forEach((key) => {
                if (!ignoredKeys.includes(key)) {
                    storage.removeItem(key);
                }
            });
        });
    },
};

export default BrowserStorage;
